import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { CountdownStyle } from '@website-builder/widgets/countdown/model/countdown-style';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class CountdownWidget extends BaseWidget<CountdownStyle> {
  readonly type = BuilderElementType.Countdown;
  style = new CountdownStyle();
  fullDateTimestamp: number;
  date: string;
  time = '00:00:00';
  daysLabel = 'DAYS';
  hoursLabel = 'HOURS';
  minutesLabel = 'MINUTES';
  secondsLabel = 'SECONDS';
  showLabels = true;
  theme = 1;

  constructor() {
    super();
    this.date = CountdownWidget.getTodayPlusOneMonth();
    this.fullDateTimestamp = Date.parse(`${this.date}T${this.time}`);
  }

  static getTodayPlusOneMonth(): string {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);

    const two = (n: number): string => n.toString().padStart(2, '0');

    return `${date.getFullYear()}-${two(date.getMonth() + 1)}-${two(date.getDate())}`;
  }

  static normalizeInPlace(widget: CountdownWidget): CountdownWidget {
    const pureWidget = new CountdownWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.fullDateTimestamp = widget.fullDateTimestamp ?? pureWidget.fullDateTimestamp;
    widget.date = widget.date ?? pureWidget.date;
    widget.time = widget.time ?? pureWidget.time;
    widget.daysLabel = widget.daysLabel ?? pureWidget.daysLabel;
    widget.hoursLabel = widget.hoursLabel ?? pureWidget.hoursLabel;
    widget.minutesLabel = widget.minutesLabel ?? pureWidget.minutesLabel;
    widget.secondsLabel = widget.secondsLabel ?? pureWidget.secondsLabel;
    widget.showLabels = widget.showLabels ?? pureWidget.showLabels;
    widget.theme = widget.theme ?? pureWidget.theme;

    widget.style = CountdownStyle.normalize(widget.style);

    return widget;
  }
}
